import { form } from './variables';

/* Default --header-height is 90px with a 17px decorative strip; a disclaimer
   replaces the strip, so each screen needs (disclaimer height + 73px) freed. */
const FOOTER_BASE = 90 - 17;

/**
 * Sizes the disclaimer strip and --header-height for EVERY widget footer in
 * one pass. The strip position (top) and the content shrink (--header-height)
 * must always be written together and with the same measured height — when
 * they diverge across screens, the freed band under a screen's content is
 * transparent and the screen underneath shows through (692's delivery-mode
 * step exposed the patient-info screen's Book Appointment button, 2026-07-31).
 */
export const applyDisclaimerFooters = () => {
    /* The module-level form holds the flat widget payload; some callers run
       before loadData() when it may still be the axios response shape. */
    const disclaimer = form?.disclaimer ?? form?.data?.disclaimer;
    if (!disclaimer) return;

    /* Hosted scheduling-link desktop pages hide widget footers entirely. */
    const assistantIframe = document.querySelector('.assistant__iframe');
    if (
        assistantIframe?.classList.contains('scheduling-link') &&
        assistantIframe?.classList.contains('desktop-ver')
    ) {
        return;
    }

    document.querySelectorAll('.widget-footer').forEach((footer) => {
        const subFooter1 = footer.querySelector('.subFooter--1');
        if (!subFooter1) return;
        subFooter1.textContent = disclaimer;
        subFooter1.classList.add('disclaimer');
        subFooter1.style.height = 'auto';
        subFooter1.style.maxHeight = '80px';
        const height = subFooter1.clientHeight;
        /* Hidden right now (closed launcher, mobile-ver, display:none screen):
           keep the current values — a later pass re-measures once visible.
           Writing 0-based values here is what desynced the screens. */
        if (!height) return;
        subFooter1.style.top = `-${height}px`;
        const mainEl =
            footer.closest('.mainMenu__container') || footer.closest('.screen');
        mainEl
            ?.querySelector('.screen__content')
            ?.style.setProperty('--header-height', `${height + FOOTER_BASE}px`);
    });
};

let resizeTimer = null;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyDisclaimerFooters, 150);
});
